var React = require('react');

function IconReportNewLeads (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,0h-.1A18,18,0,1,0,18,0Zm0,32.57a14.57,14.57,0,0,1-.1-29.14V18L28.37,7.78A14.58,14.58,0,0,1,18,32.57Z"}));
}

IconReportNewLeads.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = IconReportNewLeads;

IconReportNewLeads.default = IconReportNewLeads;
